'use client'

import { useEffect, useState, useCallback } from 'react'
import { CommandDialog, CommandEmpty, CommandInput, CommandList } from '@/components/v2/ui/command'
import { useTexts } from '@/contexts/LanguageContext'
import { OrganizationSearch } from './OrganizationSearch'
import { SidebarNavigationSearch } from './SidebarNavigationSearch'

export function CommandSearch() {
  const [isOpen, setIsOpen] = useState(false)
  const { TENANTS } = useTexts()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault()
        setIsOpen((prev) => !prev)
      }
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  const handleClose = useCallback(() => {
    setIsOpen(false)
  }, [])

  return (
    <CommandDialog
      open={isOpen}
      onOpenChange={setIsOpen}
      title={TENANTS.COMMAND_SEARCH.TITLE}
      description={TENANTS.COMMAND_SEARCH.DESCRIPTION}
      showCloseButton={false}
    >
      <CommandInput placeholder={TENANTS.COMMAND_SEARCH.PLACEHOLDER} />
      <CommandList>
        <CommandEmpty>{TENANTS.COMMAND_SEARCH.NO_RESULTS}</CommandEmpty>
        <SidebarNavigationSearch onSelect={handleClose} />
        <OrganizationSearch onSelect={handleClose} />
      </CommandList>
    </CommandDialog>
  )
}
